import $ from 'jquery';
import 'webpack-jquery-ui';
import 'jquery-ui-touch-punch';
import {compose, v$} from './helpers.js';
import {draggableInput, draggableInputFocus} from './rangeSlider';

const wrapJewelryTab = ({product, parent}) => {
    //jewelry
    const inputs = v$('input, select', parent),
        selects = v$('select', parent),
        checkboxes = v$('input[type="checkbox"]', parent),
        sum = v$('.appliances_result', parent),
        gramInput = v$('[data-grams]', parent)[0],
        resultInfo = $('.auto-state-calc'),
        multiplierInputs = v$('[data-multiplier]', parent),
        appliancesResultGold = v$('.appliances_result')[0],
        appliancesResult = v$('.appliances_result', parent)[0];

    if ($(parent).data['one-day']){
        product += '_one_day';
    }
    // let initialCursorPosition = null;
    // let isDraged = false;
    const getGrams = gramInput => {
        return parseFloat(gramInput.value) ? parseFloat(gramInput.value) : 0;
    };

  const getPercent = getGrams => {
    let diapason = getCurrentDiapason(window[product+'_diapasons'], getGrams);
    let price = diapason['price'] ? diapason['price'] : 0;
    let maxPrice = diapason['max_price'] ? diapason['max_price'] : 0;
    let scrapPrice = diapason['scrap_price'] ? diapason['scrap_price'] : 0;
    let is_scrap = $(parent).find('[name="scrap"]').is(':checked');
    let defaultProbe = $(parent).find('[name="probe"] option')[0].value;
    let probe = $(parent).find('[name="probe"]').val();
    let clientTypeMultiplier = $(parent).find('[name="client-type"]').val();

    resultInfo.hide();

    let multiplier = clientTypeMultiplier * (probe / defaultProbe);
    const multipliersSum = (is_scrap ? scrapPrice : price) * multiplier;
    const maxSum = (is_scrap ? 0 : maxPrice) * multiplier;
    window.calc_params ={
      'getGrams': getGrams,
      'clientTypeMultiplier':clientTypeMultiplier,
      'defaultProbe':defaultProbe,
      'scrapPrice':scrapPrice,
      'probe':probe,
      'maxPrice':maxPrice,
      'multiplier':multiplier,
      'price':price,
      'multipliersSum':multipliersSum,
      'maxSum':maxSum,
    };
    return {
      multipliersSum,
      maxSum,
      getGrams
    };
  };

  const getCurrentDiapason = function(diapasons, weight) {
    let fittedDiapasons = [];
    for (let i in diapasons) {
      let diapason = diapasons[i];
      let lowerLimit = +diapason['lower_weight_limit'];
      let upperLimit = +diapason['upper_weight_limit'];

      if (
        weight >= lowerLimit
        && (
          !upperLimit
          || weight <= upperLimit
        )
      ) {
        fittedDiapasons.push(diapason);
      }
    }

    let bestPrecision = null;
    let bestPrecisionIndex = null;
    for (let i in fittedDiapasons) {
      let diapason = fittedDiapasons[i];
      let upperLimit = +diapason['upper_weight_limit'];
      let lowerLimit = +diapason['lower_weight_limit'];
      if (
        (!lowerLimit || !upperLimit)
        && bestPrecisionIndex === null
      ) {
        bestPrecisionIndex = i;
        continue;
      }

      if (
        bestPrecision === null
        || bestPrecision < Math.abs(upperLimit - lowerLimit)
      ) {
        bestPrecisionIndex = i;
        bestPrecision = Math.abs(upperLimit - lowerLimit);
      }
    }

    return fittedDiapasons[bestPrecisionIndex];
  }

    const renderTotalSum = ({multipliersSum, maxSum, getGrams}) => {

        let sumSuffix = '';
        if (
          maxSum !== 0
          && maxSum !== multipliersSum
        ) {
            resultInfo.show();
            sumSuffix = ' - ' + (maxSum * getGrams).toFixed();
        }

        let totalSum = multipliersSum !== 0 ? multipliersSum * getGrams : getGrams;
        let appliancesResGold = document.querySelectorAll(
            '.creditsOneDay-main-right-calc .tabs_inner-label'
        )[0];
        let appliancesResGoldMain = document.querySelectorAll(
            '.main-tabs .tabs_inner-label'
        )[0];
        let onePageCalc = document.querySelectorAll('.one_page_calc')[0];
        if (onePageCalc) {
            appliancesResult.innerText = totalSum.toFixed() + sumSuffix;
            return;
        }
        if (
            (appliancesResGold &&
                appliancesResGold.classList.contains('active-tab')) ||
            (!appliancesResGold &&
                appliancesResGoldMain.classList.contains('active-tab'))
        ) {
            appliancesResultGold.innerText = totalSum.toFixed() + sumSuffix;
        } else {
            appliancesResult.innerText = totalSum.toFixed() + sumSuffix;
        }
    };

    let timerId =null;
    const handleInputsChange = (gramInput)=>{
      if (timerId){
        clearTimeout(timerId);
      }
      timerId = setTimeout(compose(renderTotalSum, getPercent, getGrams),50,gramInput);
    }

    inputs.forEach(item => {
        item.addEventListener('input', e => {
            handleInputsChange(gramInput);
        });
    });

    selects.forEach(item => {
        item.addEventListener('change', e => {
            handleInputsChange(gramInput);
        });
    });

    checkboxes.forEach(item => {
        item.addEventListener('change', e => {
            handleInputsChange(gramInput);
        });
    });

    let showBlockBtns = v$('input[type="radio"]', parent),
        Block = v$('.stones_info', parent)[0];
    showBlockBtns.forEach(item => {
        item.addEventListener('change', e => {
            if (item.checked && item.getAttribute('value') == 'visible') {
                Block.className = 'stones_info';
            } else {
                Block.className = 'stones_info hidden';
            }
        });
    });
    //UI Draggable Inputs
    draggableInput(parent, handleInputsChange, gramInput, 0);
    draggableInputFocus();

    /*
    --- какойто стремный кусок говна, если через 2-3 месяца не всплывет - удалить к хуям
      let goldBaseSample = $('#scrap_gold').val();
      $('.tabs_inner-label').on('click', function () {
          setTimeout(function () {
              $('#scrap_gold').val(goldBaseSample);
          }, 0);
      });
      let silverBaseSample = $('#scrap_silver').val();
      $('.tabs_inner-label').on('click', function () {
          setTimeout(function () {
              $('#scrap_silver').val(silverBaseSample);
          }, 0);
      });
    */

};

let silverGoldInputs = v$('input[data-number]');

silverGoldInputs.forEach((item) => {
    item.addEventListener('keydown', (e) => {
        const reg = /^\d+$/;
        if ((!reg.test(e.key)) && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '.'].includes(e.key)) {
            e.preventDefault();
        }
    });
    item.addEventListener('paste', (e) => {
        e.preventDefault();
    });
});


export default wrapJewelryTab;
